import { useRecoilState } from 'recoil';
import { reportCutoffState } from '../state.js';
import { useApi } from '../hooks.js';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select.js';
import { fmtMonthLong } from '../utils.js';

const LATEST = 'latest';

/** Picks which month-end the dashboard/print report shows. Always fetches the
 * FULL (unfiltered) series for its own option list, independent of whatever
 * cutoff is currently selected — otherwise picking an earlier month would hide
 * every later one from being picked again. */
export function CutoffDropdown({ clientId }: { clientId: string | null }) {
  const [cutoff, setCutoff] = useRecoilState(reportCutoffState);
  const { data: portfolio } = useApi<{ months: { date: string }[] }>(
    clientId ? `/clients/${clientId}/portfolio` : null,
  );

  const dates = [...new Set((portfolio?.months ?? []).map((m) => m.date))].sort().reverse();
  if (dates.length < 2) return null; // nothing to pick between

  return (
    <Select dir="rtl" value={cutoff ?? LATEST} onValueChange={(v) => setCutoff(v === LATEST ? null : v)}>
      <SelectTrigger className="min-w-32">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={LATEST}>החודש הנוכחי</SelectItem>
        {dates.map((d) => (
          <SelectItem key={d} value={d}>
            {fmtMonthLong(d)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
